const MAX_VISITOR_ID_LENGTH = 256;

/**
 * Normalizes and validates a trusted first-party visitor identifier.
 * Returns the normalized id, or undefined when the value is invalid.
 */
export function normalizeVisitorId(value: unknown): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }
  const trimmed = value.trim();
  if (!trimmed || trimmed.length > MAX_VISITOR_ID_LENGTH) {
    return undefined;
  }
  if (trimmed.includes('@')) {
    return undefined;
  }
  if (/\s/.test(trimmed)) {
    return undefined;
  }
  return trimmed;
}
